module.exports = __webpack_public_path__ + "static/media/1.b1ab3227.webp";